import moment from "moment";
import React, { useEffect, useState } from "react";
import { msToString } from "../helpers/time";
import BigTimeInternals from "./BigTimeInternals";

export default function BigTimeToTod({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	cuePreview = false,
}) {
	const [t, setT] = useState();

	useEffect(() => {
		let intervalId;
		clearInterval(intervalId);

		intervalId = 
			setInterval(() => {
				let now = moment().format("x");
				let end = moment(cue.endTime).format("x");
				let diff = end - now;
				if (diff < 100 && cue.onEnd === "hold") {
					return setT(0);
				}
				setT(diff);
			}, 100)

		return () => {
			clearInterval(intervalId);
		};
	}, [cue.endTime, cue.onEnd]);

	if (cuePreview) {
		return <>{msToString(t)}</>;
	}

	return (
		<BigTimeInternals
			cue={cue}
			time={t}
			cloud={cloud}
			baseTheme={baseTheme}
			baseThemeId={baseThemeId}
		/>
	);
}
